const HttpSettingsSection: React.FC = () => {
  return (
    <>
      <p>HTTP Settings coming soon..</p>
    </>
  );
};
export default HttpSettingsSection;
